import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "marginBottom" }
const _hoisted_4 = {
  key: 0,
  class: "article-info"
}
const _hoisted_5 = { class: "content-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_AccessDeniedBanner = _resolveComponent("AccessDeniedBanner")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_DashboardTab = _resolveComponent("DashboardTab")!
  const _component_HistoriqueDemandeInterventionsTab = _resolveComponent("HistoriqueDemandeInterventionsTab")!
  const _component_HistoriqueTravauxTab = _resolveComponent("HistoriqueTravauxTab")!
  const _component_InterventionsPreventivesTab = _resolveComponent("InterventionsPreventivesTab")!
  const _component_HistoriqueDevisTab = _resolveComponent("HistoriqueDevisTab")!
  const _component_CaracteristiquesTab = _resolveComponent("CaracteristiquesTab")!
  const _component_MaintenancesTab = _resolveComponent("MaintenancesTab")!
  const _component_DocumentsReglementairesTab = _resolveComponent("DocumentsReglementairesTab")!
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_ctx.forbidden)
        ? (_openBlock(), _createBlock(_component_AccessDeniedBanner, {
            key: 1,
            message: _ctx.$t('equipement.accessDenied.message')
          }, null, 8, ["message"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('equipementSelection.table.equipement')) + " ", 1),
                _createVNode(_component_ReglePastille, { cle: "equipementDetail.definition" }),
                _createVNode(_component_ReglePastille, { cle: "equipementDetail.ongletsReutilises" })
              ]),
              (!_ctx.preavisLoading && !_ctx.hasPreavisForEquipement)
                ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                    key: 0,
                    imgUrl: _ctx.addImageUrl,
                    "on-click": _ctx.openPreavisCreate,
                    title: _ctx.$t('modale.preavisIntervention.button.create'),
                    class: "btn-preavis"
                  }, null, 8, ["imgUrl", "on-click", "title"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ReglePastille, { cle: "equipementDetail.preavisUnique" })
            ]),
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.detailsEquipement.libelle), 1),
            (_ctx.detailsEquipement.phaseLibelle && _ctx.detailsEquipement.phaseLibelle.trim().toLowerCase() !== 'maintenance')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.detailsEquipement.phaseLibelle), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Tabs, {
                activeTabId: _ctx.activeTabId,
                "onUpdate:activeTabId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTabId) = $event)),
                tabs: _ctx.tabs
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_DashboardTab, {
                    "phase-id": _ctx.phaseId,
                    visible: _ctx.activeTabId === 'dashboard'
                  }, null, 8, ["phase-id", "visible"]), [
                    [_vShow, _ctx.activeTabId === 'dashboard']
                  ]),
                  (_ctx.activeTabId === 'historiqueDemandeInterventions')
                    ? (_openBlock(), _createBlock(_component_HistoriqueDemandeInterventionsTab, {
                        key: 0,
                        "phase-id": _ctx.phaseId
                      }, null, 8, ["phase-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabId === 'historiqueTravaux')
                    ? (_openBlock(), _createBlock(_component_HistoriqueTravauxTab, {
                        key: 1,
                        "phase-id": _ctx.phaseId
                      }, null, 8, ["phase-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabId === 'interventionsPreventives')
                    ? (_openBlock(), _createBlock(_component_InterventionsPreventivesTab, {
                        key: 2,
                        equipement: _ctx.detailsEquipement,
                        "phase-id": _ctx.phaseId
                      }, null, 8, ["equipement", "phase-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabId === 'historiqueDevis')
                    ? (_openBlock(), _createBlock(_component_HistoriqueDevisTab, {
                        key: 3,
                        "phase-id": _ctx.phaseId
                      }, null, 8, ["phase-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabId === 'caracteristiques')
                    ? (_openBlock(), _createBlock(_component_CaracteristiquesTab, {
                        key: 4,
                        phaseId: _ctx.phaseId
                      }, null, 8, ["phaseId"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabId === 'gammeMaintenance')
                    ? (_openBlock(), _createBlock(_component_MaintenancesTab, {
                        key: 5,
                        "phase-id": _ctx.phaseId
                      }, null, 8, ["phase-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.activeTabId === 'docReglementaires')
                    ? (_openBlock(), _createBlock(_component_DocumentsReglementairesTab, {
                        key: 6,
                        "phase-id": _ctx.phaseId
                      }, null, 8, ["phase-id"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["activeTabId", "tabs"])
            ])
          ], 64))
  ]))
}